import React, { useState } from "react";
import { Form, Button, Spinner, Container, Row, Col, Card, Alert } from "react-bootstrap";
import axios from "axios";
import { message } from "antd";
import BuyerVisitorForm from "./BuyerVisitorForm";
import "../../stylecss/mainpage.css"; // Assuming main styles are here
import MainLogo from "../../assets/boj-images/dark_boj.png";
import useBranding from "../../hooks/useBranding";

const BuyerLogin = () => {
    const { logoUrl } = useBranding();
    const [step, setStep] = useState(1); // 1: Phone, 2: OTP, 3: Form
    const [mobileNumber, setMobileNumber] = useState("");
    const [otp, setOtp] = useState("");
    const [barcode, setBarcode] = useState(null);
    const [loading, setLoading] = useState(false);
    const [userData, setUserData] = useState(null);

    // Step 1: Send OTP
    const handleSendOtp = async (e) => {
        e.preventDefault();
        if (!mobileNumber || mobileNumber.length !== 10) {
            message.error("Please enter a valid 10-digit mobile number");
            return;
        }

        setLoading(true);
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_END_POINT}/add-number-in-list`,
                { mobile_number: mobileNumber }
            );

            if (response.data.otp_send) {
                setBarcode(response.data.barcode);
                message.success("OTP sent successfully!");
                setStep(2);
            } else {
                message.error(response.data.message || "Failed to send OTP");
            }
        } catch (error) {
            console.error("Send OTP Error:", error);
            message.error(error.response?.data?.message || "Something went wrong sending OTP");
        } finally {
            setLoading(false);
        }
    };

    // Step 2: Verify OTP
    const handleVerifyOtp = async (e) => {
        e.preventDefault();
        if (!otp) {
            message.error("Please enter the OTP");
            return;
        }

        setLoading(true);
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_END_POINT}/otp-varification`,
                { otp, barcode }
            );

            if (response.data.otp_check) {
                setUserData(response.data.data);
                message.success("Verified successfully!");
                setStep(3);
            } else {
                message.error(response.data.message || "Invalid OTP");
            }
        } catch (error) {
            console.error("Verify OTP Error:", error);
            message.error(error.response?.data?.message || "Verification failed");
        } finally {
            setLoading(false);
        }
    };

    if (step === 3 && userData) {
        return <BuyerVisitorForm preloadedData={userData} />; // Will modify BuyerVisitorForm to accept this
    }

    return (
        <div className="buyer-login-container d-flex align-items-center justify-content-center" style={{ minHeight: "100vh", background: "#f8f9fa" }}>
            <Container>
                <Row className="justify-content-center">
                    <Col md={6} lg={5}>
                        <Card className="shadow-sm border-0 p-4">
                            <Card.Body>
                                <div className="text-center mb-4">
                                    <img
                                        src={logoUrl || MainLogo}
                                        alt="Logo"
                                        style={{ maxHeight: "220px", marginBottom: "20px" }}
                                    />
                                    <h3 className="font-weight-bold">{step === 1 ? "Buyer Login" : "Verify OTP"}</h3>
                                    <p className="text-muted">
                                        {step === 1
                                            ? "Enter your registered mobile number to proceed."
                                            : `Enter the 4-digit OTP sent to ${mobileNumber}`}
                                    </p>
                                </div>

                                {step === 1 && (
                                    <Form onSubmit={handleSendOtp}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Mobile Number</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Enter 10-digit mobile number"
                                                value={mobileNumber}
                                                onChange={(e) => setMobileNumber(e.target.value.replace(/\D/g, "").slice(0, 10))}
                                                maxLength={10}
                                                required
                                                size="lg"
                                            />
                                        </Form.Group>
                                        <Button variant="dark" type="submit" className="w-100" size="lg" disabled={loading}>
                                            {loading ? <Spinner animation="border" size="sm" /> : "Send OTP"}
                                        </Button>
                                    </Form>
                                )}

                                {step === 2 && (
                                    <Form onSubmit={handleVerifyOtp}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Enter OTP</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Enter OTP"
                                                value={otp}
                                                onChange={(e) => setOtp(e.target.value.replace(/\D/g, ""))}
                                                maxLength={6}
                                                required
                                                size="lg"
                                                autoFocus
                                            />
                                        </Form.Group>
                                        <Button variant="dark" type="submit" className="w-100 mb-3" size="lg" disabled={loading}>
                                            {loading ? <Spinner animation="border" size="sm" /> : "Verify & Login"}
                                        </Button>
                                        <Button
                                            variant="link"
                                            className="w-100 text-muted"
                                            onClick={() => setStep(1)}
                                            disabled={loading}
                                        >
                                            Change Mobile Number
                                        </Button>
                                    </Form>
                                )}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default BuyerLogin;
